export enum ExternalAttachmentTypeEnum {
  YoutubeVideo = 'external_youtubeVideo',
  VimeoVideo = 'external_vimeoVideo',
}
